<form class="full-size-block" [formGroup]="form_group">
  <ng-container *ngIf="!design_pattern ||design_pattern == 1">
    <label *ngIf="label_block && !hide_label" class="m-0 html-label" [ngClass]="{'req':mandatory}"
      [innerHtml]="label | HTMLFormatter"></label>
    <mat-form-field #hidden_input id="{{random_id}}" style="margin-bottom : 0px;" floatLabel="always"
      [ngClass]="{'mat-focused':show_list,'read-only':disabled,'default-read-only':default_readonly}">
      <mat-label *ngIf=" !enable_virtual_scroll && !label_block&&mandatory&& !hide_label"
        [innerHtml]="label | HTMLFormatter">
      </mat-label>
      <mat-label *ngIf=" !enable_virtual_scroll &&!label_block&&!mandatory&& !hide_label"
        [innerHtml]="label | HTMLFormatter">
      </mat-label>
      <mat-label *ngIf=" enable_virtual_scroll &&!hide_label">
        {{label}}
        <i class="fa fa-spinner fa-spin mr-2 x" matSuffix *ngIf="fetching_masters" style="cursor: pointer;"></i>

      </mat-label>
      <input style="display: none;" type="text" placeholder="{{placeholder}}" matInput
        [formControl]="form_group.get([form_control])" [readonly]="disabled ? true : false" [name]="random_id">
      <span class="d-inline-block" *ngIf="!disabled"
        [style.width]="(control_class != 'overflow-tm-select')?(selected_options_title.length ? '32%' : '100%'):'100%'">
        <input
          [ngClass]="{'with-options':selected_options_title.length, 'overflow-tm-select': control_class == 'overflow-tm-select'}"
          [style.width]="'calc(100% - 10px)'" #search_input style="z-index: 1001;display: inline-block;" type="text"
          placeholder="{{placeholder}}" (keydown)="checkForTab($event)" (click)="showList($event)"
          (focusin)="wait_till_content_loading ?showList($event): ''" (keyup)="searchKeyPress($event)" matInput
          [formControl]="search" [readonly]="disabled ? true : false" [name]="random_id">

        <i style="display: inline-block;" (click)="showList($event)" class="fa fa-angle-down" *ngIf="!disabled"></i>
      </span>
      <span class="selected-items" [ngStyle]="{'width':disabled?'96%':'69%'}"
        [ngClass]="{'allow-overflow':control_class == 'overflow-tm-select'}"
        *ngIf="selected_options_title && selected_options_title.length">
        <span class="selected-item" *ngFor="let opt of selected_options_title; let index=index;">
          {{opt}}
          <i class="fa fa-times" matSuffix (click)="clearValue($event, index)"
            *ngIf="form_group.get(form_control).value && !disabled" style="cursor: pointer;"></i>
        </span>
      </span>
      <i class="fa fa-times x" matSuffix (click)="clearAll($event)"
        *ngIf="form_group.get(form_control).value && form_group.get(form_control).value.length && !disabled"
        style="cursor: pointer;"></i>

      <i class="fa fa-plus ml-2 x" matSuffix (click)="openAddMasterModal()" *ngIf="master_form_code"
        style="cursor: pointer;"></i>
      <button matSuffix class="btn ml-2 btn-sm js-btn-save-outline pointer" style="margin-top: -7px;"
        [title]="'Create New/Modify'" *ngIf="addFunc && !disabled" (click)="suffixButtonClicked()">
        <i class="fa {{suffix_btn_icon}}"></i>
      </button>
      <button matSuffix class="btn ml-2 btn-sm js-btn-save-outline pointer" style="margin-top: -7px;"
        [title]="secondary_suffix_title" *ngIf="addFunc && !disabled && secondary_suffix_btn"
        (click)="suffixButtonClicked(2)">
        <i class="fa {{secondary_suffix_btn}}"></i>
      </button>
      <mat-error *ngIf="form_group.get([form_control]).hasError('required')">
        Field is mandatory
        <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
      </mat-error>

      <!-- <ng-template #maxlength>
            <mat-error *ngIf="form_group.get([form_control]).hasError('maxlength');else minlength">
                Maximum length ({{maxLength}}) has exceeded
            </mat-error>
        </ng-template>
        <ng-template #minlength>
            <mat-error *ngIf="form_group.get([form_control]).hasError('minlength');else maxvalue">
                Minimum length must be {{minLength}} digits
            </mat-error>
        </ng-template> -->
      <!-- <ng-template #maxvalue>
            <mat-error *ngIf="form_group.get([form_control]).hasError('max');else minvalue">
                Value must be lesser than {{maxValue}}
            </mat-error>
        </ng-template>
        <ng-template #minvalue>
            <mat-error *ngIf="form_group.get([form_control]).hasError('min')">
                Value must be greater than {{minValue}}
            </mat-error>
        </ng-template> -->
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="design_pattern == 2">
    <div [ngClass]="{'has-error':form_group.get([form_control]).hasError('required')||form_group.get([form_control]).hasError('maxlength')||
    form_group.get([form_control]).hasError('minlength') ||form_group.get([form_control]).hasError('max')
    ||form_group.get([form_control]).hasError('min') || form_group.get([form_control]).hasError('pattern'),
    'has-success': !form_group.get([form_control]).hasError('required') && !form_group.get([form_control]).hasError('maxlength')&&
    !form_group.get([form_control]).hasError('minlength') && !form_group.get([form_control]).hasError('max')
    &&!form_group.get([form_control]).hasError('min') && !form_group.get([form_control]).hasError('pattern')}"
      #hidden_input>
      <div class="row form-group">
        <div [class]="'col-md-'+(label_width || 12)" *ngIf="label&& !hide_label">
          <label class="design-2-label html-label" [ngClass]="label_class && label_class!='' ?label_class:''"
            [ngStyle]="label_css | AddNgStylePipe : {}" [innerHtml]="label | HTMLFormatter"
            [title]="label | HTMLFormatter">
          </label>
        </div>
        <input style="display: none;" type="text" autocomplete="off" placeholder="{{placeholder}}" matInput
          [formControl]="form_group.get([form_control])">

        <div [class]="'col-md-'+(control_width || 12)">
          <div class="input-group" style="padding: 0% !important;"
            [ngClass]="control_class && control_class!='' ?control_class:''"
            [ngStyle]="control_css | AddNgStylePipe : {}">
            <input #search_input [id]="random_id" style=" z-index: 1;display: inline-block;" type="text"
              autocomplete="off" class="form-control bootstrap-input" [id]=" random_id" placeholder="{{placeholder}}"
              (keydown)="checkForTab($event)" (click)="showList($event)" (focusin)="showList($event);"
              (keyup)="searchKeyPress($event)" [formControl]="search">
            <div class="input-group-append">
              <span class="input-group-text py-0 px-2 date-btn"
                *ngIf="selected_options_title && selected_options_title.length">
                {{selected_options_title && selected_options_title.length}}
              </span>
              <span class="input-group-text py-0 px-2 date-btn"
                *ngIf="form_group.get(form_control).value && form_group.get(form_control).value.length && !disabled">
                <i class="fa fa-times " matSuffix (click)="clearAll($event)" style="cursor: pointer;"></i>
              </span>
              <span class="input-group-text py-0 px-2 date-btn">


                <i (click)="showList($event)" class="fa fa-angle-down" *ngIf="!disabled"></i>
                <i class="fa fa-plus ml-1 x" matSuffix (click)="openAddMasterModal()" *ngIf="master_form_code"
                  style="cursor: pointer;"></i>
              </span>

            </div>
            <!-- <span class="selected-items" *ngIf="selected_options_title && selected_options_title.length"
              style="z-index:1001">
              <span class="selected-item" *ngFor="let opt of selected_options_title; let index=index;">
                {{opt}}
                <i class="fa fa-times" matSuffix (click)="clearValue($event, index)"
                  *ngIf="form_group.get(form_control).value" style="cursor: pointer;"></i>
              </span>
            </span> -->
          </div>
        </div>
      </div>
      <!-- <div class="input-group">
            <input type="text" class="form-control" placeholder="Amount">
            <div class="input-group-append">
                <span class="input-group-text">.040</span>
            </div>
        </div> -->
      <!-- <mat-error *ngIf="form.get([form_control]).hasError('required');else maxlength">
        Field is mandatory
    </mat-error>
    <ng-template #maxlength>
        <mat-error *ngIf="form.get([form_control]).hasError('maxlength');else minlength">
            Maximum length ({{maxLength}}) has exceeded
        </mat-error>
    </ng-template>
    <ng-template #minlength>
        <mat-error *ngIf="form.get([form_control]).hasError('minlength');else maxvalue">
            Minimum length must be {{minLength}} digits
        </mat-error>
    </ng-template>
    <ng-template #maxvalue>
        <mat-error *ngIf="form.get([form_control]).hasError('max');else minvalue">
            Value must be lesser than {{maxValue}}
        </mat-error>
    </ng-template>
    <ng-template #minvalue>
        <mat-error *ngIf="form.get([form_control]).hasError('min'); else pattern">
            Value must be greater than {{minValue}}
        </mat-error>
    </ng-template>
    <ng-template #pattern>
        <mat-error *ngIf="form.get([form_control]).hasError('pattern')">
            {{pattern_desc || 'Invalid input'}}
        </mat-error>
    </ng-template> -->
    </div>
  </ng-container>
  <ng-container *ngIf="design_pattern == 4">
    <label *ngIf="label_block && !hide_label" class="m-0 html-label" [ngClass]="{'req':mandatory}"
      [innerHtml]="label | HTMLFormatter"></label>
    <mat-form-field #hidden_input id="{{random_id}}" [appearance]="appearance" style="margin-bottom : 0px;"
      floatLabel="always" [ngClass]="{'mat-focused':show_list,'read-only':disabled}">
      <mat-label [ngClass]="{'req':!label_block&&mandatory&&label,'enable-label-action':label_action_type}"
        *ngIf="!label_block&&label">
        {{label |translate}}
        <ng-container *ngIf="label_action_type==1">
          <span>
            ( {{label_action_title}}
            <span class="link" (click)="suffixButtonClicked(99)">
              {{'TM-SELECT.clickHere'|translate}}
            </span>
            )
          </span>
        </ng-container>

      </mat-label>
      <input style="display: none;" type="text" placeholder="{{placeholder}}" matInput
        [formControl]="form_group.get([form_control])" [readonly]="disabled ? true : false" [name]="random_id">
      <span class="d-inline-block" *ngIf="!disabled"
        [style.width]="(control_class != 'overflow-tm-select')?(selected_options_title.length ? '32%' : '100%'):'100%'">
        <input
          [ngClass]="{'with-options':selected_options_title.length, 'overflow-tm-select': control_class == 'overflow-tm-select'}"
          [style.width]="'calc(100% - 10px)'" #search_input style="z-index: 1001;display: inline-block;" type="text"
          placeholder="{{placeholder}}" (keydown)="checkForTab($event)" (click)="showList($event)"
          (focusin)="showList($event);" (keyup)="searchKeyPress($event)" matInput [formControl]="search"
          [readonly]="disabled ? true : false" [name]="random_id">

        <i style="display: inline-block;" (click)="showList($event)" class="fa fa-angle-down" *ngIf="!disabled"></i>
      </span>
      <span class="selected-items" [ngStyle]="{'width':disabled?'96%':'69%'}"
        [ngClass]="{'allow-overflow':control_class == 'overflow-tm-select'}"
        *ngIf="selected_options_title && selected_options_title.length">
        <span class="selected-item" *ngFor="let opt of selected_options_title; let index=index;">
          {{opt}}
          <i class="fa fa-times" matSuffix (click)="clearValue($event, index)"
            *ngIf="form_group.get(form_control).value && !disabled" style="cursor: pointer;"></i>
        </span>
      </span>
      <i class="fa fa-times x" matSuffix (click)="clearAll($event)"
        *ngIf="form_group.get(form_control).value && form_group.get(form_control).value.length && !disabled"
        style="cursor: pointer;"></i>
      <i class="fa fa-plus ml-2 x" matSuffix (click)="openAddMasterModal()" *ngIf="master_form_code"
        style="cursor: pointer;"></i>
      <button matSuffix class="btn ml-2 btn-sm js-btn-save-outline pointer" style="margin-top: -7px;"
        *ngIf="addFunc && !disabled" (click)="suffixButtonClicked(100)">
        <i class="fa {{suffix_btn_icon}}"></i>
      </button>
      <mat-error *ngIf="form_group.get([form_control]).hasError('required')">
        Field is mandatory
        <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
      </mat-error>

      <!-- <ng-template #maxlength>
            <mat-error *ngIf="form_group.get([form_control]).hasError('maxlength');else minlength">
                Maximum length ({{maxLength}}) has exceeded
            </mat-error>
        </ng-template>
        <ng-template #minlength>
            <mat-error *ngIf="form_group.get([form_control]).hasError('minlength');else maxvalue">
                Minimum length must be {{minLength}} digits
            </mat-error>
        </ng-template> -->
      <!-- <ng-template #maxvalue>
            <mat-error *ngIf="form_group.get([form_control]).hasError('max');else minvalue">
                Value must be lesser than {{maxValue}}
            </mat-error>
        </ng-template>
        <ng-template #minvalue>
            <mat-error *ngIf="form_group.get([form_control]).hasError('min')">
                Value must be greater than {{minValue}}
            </mat-error>
        </ng-template> -->
    </mat-form-field>
  </ng-container>


  <cdk-virtual-scroll-viewport #options_list_view [id]="random_id + 'list'+1"
    style="z-index:1001;opacity: 1; pointer-events: auto;color: black;position:fixed;background-color: white;top: 45px;overflow:auto"
    *ngIf="show_list" itemSize="40" class="viewport select-menu" [style.width.px]="container_width"
    (scrolledIndexChange)="getNextBatch($event);" [style.left.px]="left" [style.top.px]="top">
    <li class="select-options"
      *ngIf=" enable_select_all&& filtered_options && filtered_options.length && filtered_options.length <300"
      (click)="selectAll()" style="background: aliceblue;
    color: var(--tallite-primary);
    border-bottom: 1px solid gainsboro;">
      <i class="fa" [ngClass]="{'fa-check-square-o': select_all, 'fa-square-o': !select_all }"></i>
      {{!select_all?'Check All':'Uncheck All'}}
    </li>
    <ng-container *cdkVirtualFor="let option of (filtered_options); let i = index">
      <li class="select-options" *ngIf="option && !enable_child_options;else hasChild" (click)="onSelect(option)"
        [class.active]="i == arrow_key_location" [value]="option[id_property]">
        <i class="fa"
          [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
        {{ option[title_property]}}

        <ng-container *ngIf="(option.icon |JSONParser : 1) && option.icon.length ;else innerHTML">
          <span *ngFor="let item of option.icon |JSONParser :1">
            <img style="height:12px;width:12px" [src]="google_storage +item.cdnPath">
          </span>
        </ng-container>

        <ng-template #innerHTML>
          <span class="ml-1" *ngIf="option.icon" [innerHTML]="option.icon | safeHTMLPipe : 'html'">

          </span>
        </ng-template>


        <ng-container *ngIf="option && option.children && option.children.length">
          <i class="fa fa-angle-right float-right bold-font"></i>
        </ng-container>
        <div *ngIf="description && description.icons && description.icons.length"
          class="d-inline-block text-right float-right"
          [style]="description && description.icons_css ? description && description.icons_css : ''">
          <ng-container *ngFor="let icon of description.icons">
            <ng-container *ngIf="option | TMSelectIconCondition : icon">
              <span (click)="iconClickFunc(icon.click_func, option)" [matTooltip]="icon.title">
                <i class="fa {{icon.class}} option-icon" *ngIf="icon.fa"></i>
                <img src="{{icon.src}}" class="{{icon.class}} option-icon" *ngIf="!icon.fa">
              </span>
            </ng-container>
          </ng-container>
          <!-- <ng-container *ngIf="option && option.children && option.children.length">
          <i class="fa fa-angle-right bold-font option-icon"></i>
        </ng-container> -->
        </div>
      </li>
      <ng-template #hasChild>
        <li class="select-options" style="font-weight: 500;" *ngIf="option && enable_child_options"
          (mouseenter)="checkChildOption(option,$event)" [class.active]="i == arrow_key_location"
          [value]="option[id_property]">
          {{ option[title_property]}}

          <ng-container *ngIf="option && option.children && option.children.length">
            <i class="fa fa-angle-right float-right bold-font"></i>
          </ng-container>
          <div *ngIf="description && description.icons && description.icons.length"
            class="d-inline-block text-right float-right"
            [style]="description && description.icons_css ? description && description.icons_css : ''">
            <ng-container *ngFor="let icon of description.icons">
              <ng-container *ngIf="option | TMSelectIconCondition : icon">
                <span (click)="iconClickFunc(icon.click_func, option)" [matTooltip]="icon.title">
                  <i class="fa {{icon.class}} option-icon" *ngIf="icon.fa"></i>
                  <img src="{{icon.src}}" class="{{icon.class}} option-icon" *ngIf="!icon.fa">
                </span>
              </ng-container>
            </ng-container>
            <!-- <ng-container *ngIf="option && option.children && option.children.length">
        <i class="fa fa-angle-right bold-font option-icon"></i>
      </ng-container> -->
          </div>
        </li>
      </ng-template>


    </ng-container>
    <li *ngIf="filtered_options == null || filtered_options == undefined || filtered_options.length == 0 "
      class="select-options"> {{no_data_found_message}} </li>
  </cdk-virtual-scroll-viewport>

  <div *ngIf="show_child_option &&  nested_menu_track && nested_menu_track['display_flag']" style="z-index: 1001">
    <ng-container
      *ngTemplateOutlet="nested_options; context: {options:child_option,nested_track : nested_menu_track['sub_menu']}">
    </ng-container>
  </div>

  <div id="overlay_mat_select_search" (click)="hideList()" *ngIf="display_overlay"
    style="position: fixed;width: 100%;height: 100%;z-index: 1000;left: 0;top: 0;">
  </div>
</form>


<!-- <form class="full-size-block" #form [formGroup]="form_group" (focusin)="showList($event); text.select()"
    (focusout)="hideList($event,1)" (keydown)="downArrow($event)">
    <mat-form-field style="margin-bottom : 0px;" floatLabel="always">
        <mat-label *ngIf="!label_block&&mandatory"  [innerHtml]="label"></mat-label>
        <mat-label *ngIf="!label_block&&!mandatory" [innerHtml]="label">
        </mat-label>
        <input type="text" autocomplete="off" placeholder="{{placeholder}}" matInput [formControl]="qwe" #text
            (keydown)="filter($event)" style="width: 25%;display: inline-block;">
        <span class="selected-items">
            <span class="selected-item" *ngFor="let opt of selected_options_title; let index=index;">
                {{opt}}
                <i class="fa fa-times" matSuffix (click)="clearValue($event, index)"
                    *ngIf="form_group.get(form_control).value" style="cursor: pointer;"></i>
            </span>
        </span>
        <i class="fa fa-angle-down" matSuffix></i>
    </mat-form-field>
    <cdk-virtual-scroll-viewport #view style="opacity: 1; pointer-events: auto;z-index: 1001;" *ngIf="show_list"
        itemSize="40" class="viewport select-menu" [style.width]="dimension_width +'px'"
        [style.position]="display_overlay ? 'fixed' : 'fixed'" [style.top.px]="top" [style.left.px]="left"
        (scrolledIndexChange)="getNextBatch($event);">
        <li class="select-options" *cdkVirtualFor="let input of filtered_input; let i = index"
            (click)="optionSelected(input)" [class.active]="i == arrow_key_location">
            <i class="fa"
                [ngClass]="{'fa-check-square-o': input['option_selected'], 'fa-square-o': !input['option_selected'] }"></i>
            {{ input[title_property] }}
        </li>
        <li *ngIf="filtered_input ==null || filtered_input == undefined || filtered_input.length == 0 "
            class="select-options"> No Records Found</li>
    </cdk-virtual-scroll-viewport>

    <div (click)="hideList($event, 2)" id="overlay_mat_select_search" *ngIf="display_overlay"
        style="position: fixed;width: 100%;height: 100%;z-index: 1000;left: 0;top: 0;"></div>
</form> -->
<ng-template #nested_options let-options="options">
  <div style="position: fixed;"
    [ngStyle]="{'left': nested_menu_track['left'] + 'px', 'top': nested_menu_track['top'] + 'px'}">
    <app-nested-options #menu [options]="this.child_option" [id_property]="id_property"
      [title_property]="title_property" [nested_menu_track]="nested_menu_track['sub_menu']" [onSelect]="onSelectRef"
      [menu_details]="nested_menu_track" [multi_select]="true">
    </app-nested-options>
  </div>
</ng-template>